<article class="type-body-large spacer-top-xl spacer-bottom-xl container-xs home-intro-block" #homeText>
  <div class="home-intro-block__summary">
    {{ summary }}
  </div>
  <div class="markdown-content home-intro-block__text" [class.home-intro-block__text--open]="openDetail" [innerHTML]="text | safe"></div>
  <button *ngIf="text" class="button-link color-gray-300 home-intro-block__toggle" (click)="toggle()">
    {{ openDetail ? 'less' : 'more' }}
  </button>
</article>
